// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"346":"49aa8e585ffc9b76e514","388":"3a4ad11dcbe5e320a904"}[chunkId] + ".js";
};